export type ChatSender = "agent" | "member";
export type DeliveryStatus = "sending" | "sent" | "failed";
export type ReplySwipeFrom = "left" | "right";

export const CHAT_REACTIONS = ["👍", "👎", "🙏", "❤️", "😊", "😞", "✅"] as const;

export type ChatReaction = (typeof CHAT_REACTIONS)[number];

export interface ChatAttachment {
    filename?: string;
    mimeType: string;
    url?: string;
    onPress?: () => void;
}

export interface ConfirmedBooking {
    id: string;
    title: string;
    imageUrl?: string;
    href?: string;
    options?: Array<{ id: string; title: string }>;
}

export interface Proposal {
    title: string;
    href?: string;
    bookings: Array<{
        id: string;
        title: string;
        imageUrl?: string;
        href?: string;
    }>;
}

export interface ChatArticle {
    id: string;
    title: string;
    subtitle?: string;
    imageUrl?: string;
    href?: string;
}

export interface ChatTaggedBooking {
    title: string;
    imageUrl?: string;
    optionTitle?: string;
}

export interface ChatMessageReply {
    id: string;
    title: string;
    message: string;
    imageUrl?: string;
    isPending?: boolean;
    onPress?: () => void;
}

export interface QuickRequest {
    title?: string;
    subtitle?: string;
    questionAnswerPairs?: Array<{ question: string; answer: string }>;
}

export interface Nomination {
    name: string;
    phone: string;
}

export interface ChatMessageProps {
    id: string;
    sender: ChatSender;
    sentAt: string;
    senderName?: string;
    avatarUrl?: string | null;
    useServiceEmblem?: boolean;
    message?: string;
    messageHtml?: string;
    label?: string;
    topic?: string;
    topicHref?: string;
    showSenderRow?: boolean;
    deliveryStatus?: DeliveryStatus;
    attachments?: ChatAttachment[];
    confirmedBookings?: ConfirmedBooking[];
    proposal?: Proposal;
    reply?: ChatMessageReply;
    articles?: ChatArticle[];
    quickRequest?: QuickRequest;
    nomination?: Nomination;
    reaction?: ChatReaction | null;
    onReply?: (messageText: string) => void;
    onReact?: (reaction: ChatReaction) => void;
    onRemoveReaction?: () => void;
    onCopy?: () => void;
    onRetrySend?: () => void;
    replySwipeFrom?: ReplySwipeFrom;
    isHighlighted?: boolean;
}
